export type AlertDialogData = {
  title?: string;
  message: string;
  translationParams?: { [key: string]: string | number };
};
